import { FormInputProps } from 'brief-form'

import { SingleSelectAutoSuggestOpts } from '../SingleSelectAutoSuggest'

export type VendorSelectOpts = Omit<SingleSelectAutoSuggestOpts, 'listName' | 'options'> & {
  filters?: { field: string; type: string; value: string | number }[]
}

export interface VendorSelectProps extends FormInputProps<number | string, VendorSelectOpts> {}
